module.exports = __webpack_public_path__ + "assets/img/6_637_big.9161fcf9.jpg";